import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component
 * Scrolls to top of page on route change, except when coming back from property details
 * to search, rentals, or community pages (which restore their own scroll position)
 * Accounts for fixed header height to prevent content from being hidden
 */
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we're navigating to search, rentals, or community pages
    const isSearchPage = location.pathname === '/search' || location.pathname.startsWith('/search/');
    const isRentalsPage = location.pathname === '/rentals' || location.pathname.startsWith('/rentals/');
    const isCommunityPage = location.pathname === '/planetre/Community';
    
    // Check if we're coming back from property details (they save scroll position in sessionStorage)
    const hasSavedScrollPosition = sessionStorage.getItem('searchScrollY') !== null;
    
    // Only skip scroll-to-top if:
    // 1. We're going to search/rentals/community pages AND
    // 2. There's a saved scroll position (meaning we're coming back from details)
    //if ((isSearchPage || isRentalsPage || isCommunityPage) && hasSavedScrollPosition) {
    if ((isSearchPage || isRentalsPage || isCommunityPage)) {
      // Don't scroll to top - let the page handle scroll restoration
      return;
    }
    
    // Calculate header + menubar height dynamically
    // The header contains the navbar/menubar, so we need the total height
    const getTotalHeaderHeight = () => {
      const mainHeader = document.querySelector('header.main-header');
      if (mainHeader) {
        // offsetHeight includes padding and borders, giving us the full visible height
        return mainHeader.offsetHeight || 0;
      }
      // Fallback: use responsive height estimates
      // Desktop: ~75-80px (header + menubar), Mobile: ~60px (based on CSS comments)
      return window.innerWidth >= 769 ? 100 : 80;
    };
    
    // Use setTimeout to ensure DOM is fully rendered before calculating height
    const scrollToTopWithOffset = () => {
      let totalHeight = getTotalHeaderHeight();
      const filterBar = document.querySelector('.filter-bar');
      if (filterBar) {
        totalHeight += filterBar.offsetHeight;
      }
      const topheaderrow = document.querySelector('.top-header-row');
      if (topheaderrow) {
        totalHeight += topheaderrow.offsetHeight;
      }
      const customHeader = document.querySelector('.custom-header');
      if (customHeader) {
        totalHeight += customHeader.offsetHeight;
      }     
      const sorthomesrow = document.querySelector('.sort-homes-row');
      if (sorthomesrow) {
        totalHeight += sorthomesrow.offsetHeight;
      }
      // Scroll to position accounting for fixed header + menubar height
      //window.scrollTo({ top: totalHeight, behavior: 'instant' });
      window.scrollTo({ top: 0, behavior: 'instant' });
    };
    
    // Small delay to ensure header is rendered
    setTimeout(scrollToTopWithOffset, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
